// Builds monogram initials from a person's name, ignoring a trailing class
// year suffix like "'19" (e.g. "Jay Lenrow '73" -> "JL").
const getInitials = (name = '') =>
  name
    .replace(/['’]\d+/g, '')
    .split(' ')
    .filter(Boolean)
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 3);

export default getInitials;
